<template>
  <div class="role-container">
    <header>
      <span class="title">角色权限</span>
      <div class="right">
        <el-button :disabled="role.id == 1" v-if="funAuth.includes(42)" type="primary" @click="queryRoleUser">管理成员</el-button>
      </div>
    </header>
    <el-container>
      <el-aside width="220px">
        <div class="item item-title">
          <i class="iconfont icon-jiaose1"></i>角色
          <i class="iconfont icon-nav-quickly-add" @click="addManage(0)" v-if="funAuth.includes(41)"></i>
        </div>
        <div class="item" v-for="(item, index) in roleList" :key="index" :class="item.id == role.id ? 'active':''" @click="roleChange($event, item)">
          <i class="iconfont icon-guanliyuan" v-if="item.sys_type == 1"></i>
          <i class="iconfont icon-fangke" v-if="item.sys_type != 1"></i>
          {{item.name}}
          <i class="iconfont icon-delete" v-if="item.id != 1 && funAuth.includes(42)"></i>
          <i class="iconfont icon-edit" v-if="item.id != 1 && funAuth.includes(42)"></i>
        </div>
      </el-aside>
      <el-container>
        <el-header>
          <i class="iconfont icon-guanliyuan" v-if="role.sys_type == 1"></i>
          <i class="iconfont icon-fangke" v-if="role.sys_type != 1"></i>
          <span class="name">{{role.name}}</span>{{role.remark}}
        </el-header>
        <el-main>
          <div class="header">
            <div class="left"><span>功能</span></div>
            <div class="right"><span>功能权限</span></div>
          </div>
          <table class="permssion-box">
            <tr v-for="(modules, mindex) in getModulePermssionList" :key="mindex">
              <td class="role-module-item">
                <el-checkbox v-model="modules.moduleCheck" v-bind:disabled="role.id == 1" :title="modules.moduleName">{{modules.name}}</el-checkbox>
              </td>
              <td class="role-fun-item">
                <div>
                  <el-checkbox v-model="modules.checkAll" @change="allPerCheck(modules, mindex)" v-bind:disabled="role.id == 1" style="margin: 0 -4px 0 30px;">全选</el-checkbox>
                  <el-checkbox v-for="(func, findex) in modules.funcList" v-model="func.authCheck" :label="func.id" :key="findex" @change="perCheck(func, modules)" v-bind:disabled="role.id == 1" :data-id="func.id">{{func.name}}</el-checkbox>
                </div>
              </td>
            </tr>
          </table>
          <div class="footer" v-if="role.id != 1 && funAuth.includes(43)">
            <el-button type="primary" @click="saveRole(0)">确 定</el-button>
          </div>
        </el-main>
      </el-container>
    </el-container>

    <el-dialog :title="(type == 0) ? '新建角色':'编辑角色'" :visible.sync="dialogManageRole" class="add-box">
      <div class="form-item">
        <span class="item-title"><span class="need">*</span>角色名</span>
        <div class="item-right">
          <el-input v-model="roleName" placeholder="请输入" size="medium" maxlength="25"></el-input>
        </div>
        <div class="err" v-if="err_rn"><i class="el-icon-warning"></i>{{err_rn}}</div>
      </div>
      <div class="form-item">
        <span class="item-title"><span class="need"></span>描述</span>
        <div class="item-right">
          <el-input v-model="roleDescribe" placeholder="请输入" size="medium" type="textarea" rows="3"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogManageRole = false">取 消</el-button>
        <el-button type="primary" @click="addRole">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note" style="min-height: 5px;">提示：删除后，该角色将无法恢复，请谨慎操作。</div>
      <div class="prompt">您确定删除职务角色？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="roleDelete">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="成员管理" :visible.sync="dialogMember" class="candidateBox">
      <div class="header">
        <div class="left" style="height: 24px;"></div>
        <div class="right">
          已选（<span>{{roleUserList.length}}</span>）<a href="javascript:;" @click="removeAll"><span>清空</span><i class="el-icon-delete"></i></a>
        </div>
      </div>
      <div class="content">
        <div class="left">
          <div class="item" v-for="(item, index) in userList" :key="index" v-if="item.role_id != 1" @click="userChange(item)">{{item.user_name}}<i class="iconfont" :class="item.checked ? 'icon-pc-member-sign-ok':'icon-pc-member-sign'"></i></div>
        </div>
        <i class="el-icon-arrow-right"></i>
        <div class="right">
          <div class="item" v-for="(item, index) in roleUserList" :key="index">{{item.user_name}}<i class="remove iconfont icon-pc-member-delet" @click="userChange(item)"></i></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogMember = false">取 消</el-button>
        <el-button type="primary" @click="saveMember">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import tool from '@/common/js/tool.js'
export default {
  data () {
    return {
      defaultMsg: '<b>角色权限</b>',
      funAuth: [],
      activeNames: ['1'],
      roleList: [],
      role: {},
      dataPermission: [],
      getModulePermssionList: [],
      disabled: true,
      dialogManageRole: false,
      type: null,
      roleName: '',
      err_rn: '',
      roleDescribe: '',
      dialogMember: false,
      userList: [],
      roleUserList: [],
      dialogDelete: false
    }
  },
  mounted () {
    this.searchValue = ''
    this.queryUserList()
    this.queryRoleList(1)
    this.queryFchBtnAuth(({moduleId: 12}))
  },
  methods: {
    queryFchBtnAuth (params) {
      HTTPServer.queryFchBtnAuth(params, '').then((res) => {
        res.map((item, index) => {
          this.funAuth.push(item.func_id)
        })
      })
    },
    /** 获取角色列表 */
    queryRoleList (type) {
      HTTPServer.queryRoleList({}, 'Loading').then((res) => {
        this.roleList = res
        if (res.length > 0 && !this.role.id) {
          this.role = res[0]
        }
        if (type === 1) {
          this.queryInitRoleAuth()
        } else if (type === 2) {
          this.queryRoleAuth(this.initRoleAuth)
        }
      })
    },
    /** 获取模块权限 */
    queryInitRoleAuth () {
      HTTPServer.queryInitRoleAuth({}, 'Loading').then((res) => {
        this.initRoleAuth = res
        this.queryRoleAuth(res)
      })
    },
    /** 获取角色权限 */
    queryRoleAuth (list) {
      // list = JSON.parse(JSON.stringify(list))
      var jsondata = {'roleId': this.role.id}
      HTTPServer.queryRoleAuth(jsondata, 'Loading').then((res) => {
        this.getModulePermssionList = res
        list.map((item, index) => {
          item.moduleCheck = false
          for (var f = 0; f < item.funcList.length; f++) {
            item.funcList[f].authCheck = false
          }
        })
        list.map((item, index) => {
          item.checkAll = false
          var contains = tool.contains(res, 'moduleId', item, 'id')
          if (contains) {
            item.moduleCheck = true
            var funcList = item.funcList
            var funcAuthList = res[contains.i].funcAuthList
            funcList.map((item2, index2) => {
              item.funcList[index2].authCheck = (funcAuthList.indexOf(item.funcList[index2].id) >= 0)
            })
            if (funcList.length === funcAuthList.length) {
              item.checkAll = (funcAuthList.length !== 0)
            }
          }
        })
        this.getModulePermssionList = list
      })
    },
    /** 切换角色 */
    roleChange (event, data) {
      var className = event.target.className
      if (className.indexOf('icon-edit') >= 0) {
        this.addManage(data)
      } else if (className.indexOf('icon-delete') >= 0) {
        this.setId = data.id
        this.dialogDelete = true
      } else {
        this.role = data
        this.queryRoleAuth(this.initRoleAuth)
      }
    },
    addManage (data) {
      data = JSON.parse(JSON.stringify(data))
      this.type = data
      if (data === 0) {
        this.roleName = ''
        this.roleDescribe = ''
        this.err_rn = ''
      } else {
        this.setId = data.id
        this.roleName = data.name
        this.roleDescribe = data.remark
        this.err_rn = ''
      }
      this.dialogManageRole = true
    },
    /** 添加、编辑角色 */
    addRole () {
      if (!this.roleName) {
        this.err_rn = '角色名不能为空'
        return
      }
      var jsondata = {}
      if (this.type === 0) {
        jsondata = {'role_name': this.roleName, 'role_remark': this.roleDescribe}
        HTTPServer.addRole(jsondata, 'Loading').then((res) => {
          this.dialogManageRole = false
          this.queryRoleList()
        })
      } else {
        jsondata = {'id': this.setId, 'role_name': this.roleName, 'role_remark': this.roleDescribe}
        HTTPServer.modifyRole(jsondata, 'Loading').then((res) => {
          this.dialogManageRole = false
          this.queryRoleList()
        })
      }
    },
    /** 删除角色 */
    roleDelete () {
      var jsondata = {'role_id': this.setId}
      HTTPServer.deleteRole(jsondata, 'Loading').then((res) => {
        this.dialogDelete = false
        this.role = {}
        this.queryRoleList(2)
      })
    },
    /** 全选权限 */
    allPerCheck (data, i) {
      data.funcList.map((item, index) => {
        item.authCheck = data.checkAll
      })
      if (data.checkAll) data.moduleCheck = true
    },
    /** 单选权限 */
    perCheck (data, obj) {
      if (data.authCheck) obj.moduleCheck = true
      var num = 0
      obj.funcList.map((item, index) => {
        if (item.authCheck) num++
      })
      obj.checkAll = (num === obj.funcList.length && num !== 0)
    },
    /** 保存角色权限 */
    saveRole () {
      var arr = []
      this.getModulePermssionList.map((item, index) => {
        if (item.moduleCheck) {
          var obj = {'moduleId': item.id, 'funcAuthList': []}
          item.funcList.map((item2, index2) => {
            if (item2.authCheck) {
              obj.funcAuthList.push({'funcAuthId': item2.id})
            }
          })
          arr.push(obj)
        }
      })
      var jsondata = {'roleId': this.role.id, 'roleAuth': arr}
      HTTPServer.modifyAuthByRole(jsondata, 'Loading').then((res) => {
      })
    },
    /** 获取账户列表 */
    queryUserList () {
      HTTPServer.queryUserList({pageSize: 9999, pageNum: 1}, 'Loading').then((res) => {
        this.userList = res.dataList
      })
    },
    /** 角色用户列表 */
    queryRoleUser () {
      var jsondata = {'roleId': this.role.id}
      HTTPServer.queryRoleUser(jsondata, 'Loading').then((res) => {
        this.userList.map((item, index) => {
          this.userList[index].checked = false
          var contains = tool.contains(res, 'id', item, 'id')
          if (contains) {
            this.userList[index].checked = true
          }
        })
        this.roleUserList = res
        this.dialogMember = true
      })
    },
    /** 权限用户选择 */
    userChange (data) {
      var contains = tool.contains(this.roleUserList, 'id', data, 'id')
      var contains2 = tool.contains(this.userList, 'id', data, 'id')
      if (contains) {
        this.roleUserList.splice(contains.i, 1)
        if (contains2) this.userList[contains2.i].checked = false
      } else {
        this.roleUserList.push({'user_name': data.user_name, 'account_name': data.account_name, 'id': data.id})
        if (contains2) this.userList[contains2.i].checked = true
      }
    },
    /** 权限用户选择 (清除所有) */
    removeAll () {
      this.userList.map((item, index) => {
        item.checked = false
      })
      this.roleUserList = []
    },
    /** 保存角色成员 */
    saveMember () {
      var arr = []
      this.roleUserList.map((item) => {
        arr.push(item.id)
      })
      var jsondata = {'role_id': this.role.id, 'account_id': arr.toString()}
      HTTPServer.savaRoleAccount(jsondata, 'Loading').then((res) => {
        this.dialogMember = false
      })
    }
  }
}
</script>

<style lang="scss">
.role-container{
  >.el-container{
    height: calc(100% - 60px);
  }
  .el-aside{
    background: none;
    border-right: 1px solid #e7e7e7;
    .el-collapse-item__header{
      height: 50px;
      line-height: 50px;
      padding-left: 10px;
      font-size: 14px;
      color: #17171A;
      border: none;
      .iconfont{
        font-size: 16px;
        margin-right: 5px;
        display: inline-block;
        transition: transform .3s,-webkit-transform .3s;
        transform: rotate(-90deg);
      }
    }
    .el-collapse-item__header.is-active{
      .iconfont{
        transform: rotate(0deg);
      }
    }
    .el-collapse{
      height: 100%;
      border: none;
    }
    .el-collapse-item{
      height: 100%;
      margin: 0;
    }
    .el-collapse-item__arrow{
      display: none;
    }
    .el-collapse-item__wrap{
      height: calc(100% - 50px);
      border-bottom: none;
    }
    .el-collapse-item__content{
      padding-bottom: 10px;
    }
    .item{
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      margin-top: 1px;
      .iconfont{
        float: right;
        margin: 0 8px 0 0;
        display: none;
        color: #999;
      }
      .iconfont:first-child{
        float: left;
        font-size: 16px;
        color: #666;
        margin: 0 8px 0 30px;
        display: inline-block;
      }
      .icon-edit{
        font-size: 14px;
      }
    }
    .item-title{
      height: 50px;
      line-height: 50px;
      cursor: default;
      .icon-jiaose1{
        margin: 0 8px 0 10px!important;
      }
      .icon-nav-quickly-add{
        float: right;
        color: #666;
        line-height: 1;
        font-size: 19px;
        margin: 15px 10px 0 0;
        cursor: pointer;
        display: inline-block;
      }
    }
    .item.active, .item:hover{
      background: #F2F2F2;
      .iconfont{
        display: inline-block;
      }
    }
  }
  .el-header{
    line-height: 60px;
    font-size: 14px;
    color: #BBBBC3;
    border-bottom: 1px solid #e7e7e7;
    .iconfont{
      font-size: 16px;
      margin: 0 5px 0 0;
      color: #666;
    }
    .name{
      font-size: 16px;
      color: #17171A;
      margin-right: 8px;
    }
  }
  .el-main{
    padding: 0;
    .header{
      height: 60px;
      line-height: 60px;
      background: #FAFAFA;
      border-bottom: 1px solid #e7e7e7;
      .left{
        width: 141px;
        float: left;
        padding-left: 30px;
        border-right: 1px solid#e7e7e7;
      }
      .right{
        width: calc(100% - 141px);
        margin-left: 141px;
        padding-left: 30px;
      }
    }
    .permssion-box{
      width: 100%;
    }
    .role-module-item{
      min-width: 80px;
      padding: 10px 10px 10px 30px;
      position: relative;
      width: 140px;
      border-right: 1px solid #e7e7e7;
    }
    tr{
      border-bottom: 1px solid #e7e7e7;
    }
    .role-fun-item{
      display: unset;
      line-height: 30px;
      >div{
        padding: 15px 0;
      }
      .checkbox-all{
        margin-left: 30px;
      }
      .el-checkbox{
        min-width: 140px;
      }
    }
    .footer{
      padding: 16px 0 17px 30px;
      .el-button{
        padding: 8px 15px;
      }
    }
  }
  .candidateBox{
    .el-dialog{
      width: 600px;
    }
    .el-dialog__body{
      padding: 0 16px;
      line-height: 24px;
    }
    .header{
      height: 40px;
      border-bottom: none;
      padding-top: 20px;
      .left{
        width: 280px;
        float: left;
      }
      .right{
        width: 238px;
        margin-left: 324px;
        >span{
          font-size: 14px;
          color: #000;
        }
        a{
          color: #1890ff;
          float: right;
        }
      }
    }
    .content{
      height: 440px;
      position: relative;
      .left{
        border: 1px solid #f2f2f2;
        width: 278px;
        height: calc(100% - 12px);
        float: left;
        border-radius: 2px;
        padding: 10px 0;
        overflow-y: auto;
        .item{
          height: 38px;
          line-height: 38px;
          margin: 1px 0;
          cursor: pointer;
          padding-left: 20px;
          .iconfont{
            float: right;
            margin-right: 15px;
          }
        }
      }
      .right{
        border: 1px solid #f2f2f2;
        width: 238px;
        height: calc(100% - 12px);
        margin-left: 324px;
        padding: 5px 0;
        border-radius: 2px;
        overflow-y: auto;
        .item{
          margin: 2px 0;
          height: 38px;
          line-height: 38px;
          padding: 0 14px;
          i.remove{
            font-size: 14px;
            cursor: pointer;
            float: right;
            margin: 13px 0 0;
            color: #f94c4a;
            line-height: 1;
          }
        }
      }
      .el-icon-arrow-right{
        font-size: 20px;
        float: left;
        margin: 170px 0 0 13px;
      }
    }
    .icon-pc-member-sign-ok{
      color: #1890ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/platform/role.vue